// ======================================================================
// File Name       : csvDownloadAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as userRequests from './httpRequests/user';
import * as courseRequest from './httpRequests/course';
import * as itemRequest from './httpRequests/item';
import * as boxRequest from './httpRequests/box';
import * as userAttributeRequest from './httpRequests/userAttribute';
import * as userHistoryStudentRequest from './httpRequests/userHistoryStudent';
import * as loginHistoryRequest from './httpRequests/loginHistory';
import * as courseActionCreators from './actionCreators/course';
import * as groupRequests from './httpRequests/group';
import * as csvActionCreators from './actionCreators/csvDownload';
import * as userActions from './UserAction';
import * as UserUtils from '../utils/UserUtils';
import { showExportCSVSuccessMessage } from '../utils/index';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../constants';
import { USER_ATTRIBUTE_TYPE } from '../constants/UserAttributeConstants';
import { PROGRESS_STATUS_CSV_TYPE, SELECTED_COMPLETION_TYPE } from '../constants/CSVDownloadConstant';


export function initServiceUserGroupList(position = 0) {
  return async (dispatch, getState) => {
    let searchInfo = {
      returnMaxNum: 20,
      startPosition: position,
      dormantState: 0,
      userType: 2,
    };
    const startPosition = 0;

    // Send request postUserGetList
    const { recordNum, userList } = await userRequests.postUserGetList({ searchInfo });
    // Create searchInfo for postUserGroupRelationGetList
    searchInfo = {
      startPosition: 0,
      userList: userList.map(({ userSecernId }) => userSecernId),
    };
    // Send request postUserGroupRelationGetList
    const { groupRelationList } = await groupRequests.postUserGroupRelationGetList({ searchInfo });

    const { groupList } = await groupRequests.postGroupGetStructure(undefined, true);

    const groupListByUser = UserUtils.convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');

    const storedUserList = getState().csvDownload.storedUserList;
    const users = userList.reduce((acc, cur) => {
      const { userSecernId } = cur;
      const groupSecernIdList =
        groupListByUser[cur.userSecernId] && groupListByUser[cur.userSecernId].groupSecernId
          ? groupListByUser[cur.userSecernId].groupSecernId
          : [];
      const nameGroup = UserUtils.convertGroupListIdToGroupName(groupSecernIdList, groupList);
      cur.groupName = nameGroup;
      acc.bySecernId[userSecernId] = cur;
      acc.allSecernIds.push(userSecernId);
      if (!storedUserList.bySecernId[userSecernId]) {
        storedUserList.bySecernId[userSecernId] = cur;
      }
      if (storedUserList.allSecernIds.indexOf(userSecernId) < 0) {
        storedUserList.allSecernIds.push(userSecernId);
      }
      return acc;
    }, { recordNum, bySecernId: {}, allSecernIds: [] });
    const searchCondition = {};
    return dispatch(csvActionCreators.receiveServiceUserList(users, recordNum, storedUserList, searchCondition));
  };
}

export function initCourseList() {
  const data = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo: {
      returnMaxNum: RETURN_MAX_NUM,
    },
  };
  return async (dispatch) => {
    const { courseList, recordNum } = await courseRequest.postCourseGetList(data);
    return dispatch(csvActionCreators.receiveCourseList(courseList, recordNum));
  };
}

export function getCourseListPaging(position) {
  const data = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo: {
      startPosition: position,
      returnMaxNum: RETURN_MAX_NUM,
    },
  };
  return async (dispatch) => {
    const { courseList, recordNum } = await courseRequest.postCourseGetList(data);
    return dispatch(csvActionCreators.receiveCourseList(courseList, recordNum));
  };
}

export function addCheckedCourseToList({ removedSecern, addedList = [], removedAll }) {
  return csvActionCreators.receiveAddedCourseList(removedSecern, addedList, removedAll);
}

export function addCheckedCourseToTargetList(addedCourseList) {
  return csvActionCreators.receiveTargetCourseList(addedCourseList);
}

export function reset(addedCourseList) {
  return csvActionCreators.resetData(addedCourseList);
}

export function resetContent(addedContentList) {
  return csvActionCreators.resetContentData(addedContentList);
}

export function resetUser(addedUserList) {
  return csvActionCreators.resetUserData(addedUserList);
}

export function searchCourse(courseName, userAttributeKeyNum, userAttributeSearchText, startPosition = 0) {
  return async (dispatch) => {
    let searchByUserAtribute = (async () => [])();
    let isAttr = false;
    let searchCondition = { courseName, userAttributeKeyNum, userAttributeSearchText };

    if (userAttributeSearchText) {
      isAttr = true;
      if (userAttributeKeyNum === 0) {
        userAttributeKeyNum = 1;
      }
      const searchInfo = {
        userAttributeType: USER_ATTRIBUTE_TYPE.COURSE,
        userAttributeKeyNum,
        userAttributeSearchText,
      };
      searchByUserAtribute = userAttributeRequest.postUserAttributeGetList({ searchInfo })
        .then(({ userAttributeList }) => userAttributeList.map(cur => cur.secernId));
    }
    const courseSecernIds = await searchByUserAtribute;

    if (!courseSecernIds.length && isAttr) {
      const targetUser = {
        bySecernId: {},
        allSecernIds: [],
        recordNum: 0,
      };
      searchCondition = {};
      return dispatch(csvActionCreators.receiveCourseList([], 0, searchCondition));
    }

    const data = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        courseName,
        returnMaxNum: RETURN_MAX_NUM,
        startPosition,
      },
    };
    if (courseSecernIds.length && isAttr) {
      data.searchInfo.courseList = courseSecernIds;
    }

    const { courseList, recordNum } = await courseRequest.postCourseGetList(data);
    if (recordNum > 0) {
      return dispatch(csvActionCreators.receiveCourseList(courseList, recordNum, searchCondition));
    }
    searchCondition = {};
    return dispatch(csvActionCreators.receiveCourseList(courseList, recordNum, searchCondition));
  };
}

export function initTargetContent(position) {
  return async (dispatch, getState) => {
    const { itemList, recordNum } = await itemRequest.postItemGetList(
      { selectTargetData: SELECT_TARGET_DATA.DATA, searchInfo: { startPosition: position || 0, returnMaxNum: RETURN_MAX_NUM } });

    const storedContentList = getState().csvDownload.storedContentList;

    const items = itemList.reduce((acc, cur) => {
      const { itemSecernId } = cur;
      acc.bySecernId[itemSecernId] = cur;
      acc.allSecernIds.push(itemSecernId);
      if (!storedContentList.bySecernId[itemSecernId]) {
        storedContentList.bySecernId[itemSecernId] = cur;
      }
      if (storedContentList.allSecernIds.indexOf(itemSecernId) < 0) {
        storedContentList.allSecernIds.push(itemSecernId);
      }
      return acc;
    }, { recordNum, bySecernId: {}, allSecernIds: [] });

    return dispatch(csvActionCreators.receiveItemList(items, recordNum, storedContentList));
  };
}

export function addCheckedContentToAddedList({ removedSecern, addedList = [], removedAll }) {
  return csvActionCreators.receiveAddedContentList(removedSecern, addedList, removedAll);
}

export function addCheckedContentToTargetList(addedContentList) {
  return csvActionCreators.receiveTargetContentList(addedContentList);
}

export function addCheckedUserToTargetList(addedUserList) {
  return csvActionCreators.receiveTargetUserList(addedUserList);
}

export function addCheckedUserServiceToAddedList({ removedSecern, addedList = [], removedAll }) {
  return csvActionCreators.receiveAddedUserList(removedSecern, addedList, removedAll);
}

export function postGetHistoryList(param, isGetStatusItem = false) {
  return async (dispatch, getState) => {
    const requestParam = {
      searchInfo: {},
      selectTargetData: SELECT_TARGET_DATA.CSV,
    };
    const {
      learningStartTimeFrom,
      learningStartTimeTo,
      dormantState,
      groupList,
      userList,
      courseList,
      itemList,
      contentTypeList,
      boxList,
      progressStatusType,
      selectedCompletionType,
    } = param;
    // Handle period cover params
    // Params: learning_start_time_from, learning_start_time_to
    learningStartTimeFrom && (requestParam.searchInfo.learningStartTimeFrom = learningStartTimeFrom);
    learningStartTimeTo && (requestParam.searchInfo.learningStartTimeTo = learningStartTimeTo);
    // Handle target user params
    // Params: dormant_state, group_list, user_list
    if (dormantState) {
      requestParam.searchInfo.dormantState = null;
    } else {
      requestParam.searchInfo.dormantState = 0;
    }
    groupList && groupList.length && (requestParam.searchInfo.groupList = groupList);
    userList && userList.length && (requestParam.searchInfo.userList = userList);
    if (userList && userList.length) {
      requestParam.searchInfo.dormantState = null;
    }
    // Handle target content
    // Handle course_list, item_list, content_type_list
    courseList && courseList.length && (requestParam.searchInfo.courseList = courseList);
    itemList && itemList.length && (requestParam.searchInfo.itemList = itemList);
    contentTypeList && contentTypeList.length && (requestParam.searchInfo.contentTypeList = contentTypeList);

    // Step 10.0.0 START
    boxList && boxList.length && (requestParam.searchInfo.boxList = boxList);

    //「コンテンツ」、「セクション」が選ばれた場合は、「完了条件達成状態」を指定する
    if (selectedCompletionType === SELECTED_COMPLETION_TYPE.COMPLETE) {
      progressStatusType === PROGRESS_STATUS_CSV_TYPE.COURSE
        ? (requestParam.searchInfo.courseStatus = 1)
        : (requestParam.searchInfo.endConditionAchievementStatus = true);
    } else if (selectedCompletionType === SELECTED_COMPLETION_TYPE.INCOMPLETE) {
      // 「コース」が選ばれた場合は、「履修状況」を指定する
      progressStatusType === PROGRESS_STATUS_CSV_TYPE.COURSE
        ? (requestParam.searchInfo.courseStatus = 0)
        : (requestParam.searchInfo.endConditionAchievementStatus = false);
    }

    // Send request
    switch (progressStatusType) {
      case PROGRESS_STATUS_CSV_TYPE.BOX:
        await userHistoryStudentRequest.postGetStatusBox(requestParam);
        break;
      case PROGRESS_STATUS_CSV_TYPE.COURSE:
        await userHistoryStudentRequest.postGetStatusCourse(requestParam);
        break;
      default:
        if (isGetStatusItem) {
          await userHistoryStudentRequest.postGetStatusItem(requestParam)
            .then(() => { showExportCSVSuccessMessage(); });
        } else {
          await userHistoryStudentRequest.postGetHistoryListByCourseList(requestParam)
            .then(() => { showExportCSVSuccessMessage(); });
        }
        break;
    }
    // Step 10.0.0 END
  };
}

export function searchContent({ contentName, boxName, contentType, contentTypeRadio,
  courseName, userAttributeKeyNum, userAttributeSearchText }, startPosition) {
  return async (dispatch, getState) => {
    let searchByUserAtribute = (async () => [])();
    let isAttr = false;
    let itemSecernIds = [];
    const storedContentList = getState().csvDownload.storedContentList;
    let searchCondition = {
      contentName,
      boxName,
      contentType,
      contentTypeRadio,
      courseName,
      userAttributeKeyNum,
      userAttributeSearchText,
    };

    if (userAttributeSearchText && userAttributeSearchText.length) {
      isAttr = true;
      if (userAttributeKeyNum === 0) {
        userAttributeKeyNum = 1;
      }
      const searchInfo = {
        userAttributeType: USER_ATTRIBUTE_TYPE.ITEM,
        userAttributeKeyNum,
        userAttributeSearchText,
      };
      searchByUserAtribute = userAttributeRequest.postUserAttributeGetList({ searchInfo })
        .then(({ userAttributeList }) => userAttributeList.map(cur => cur.secernId));

      itemSecernIds = await searchByUserAtribute;
    }

    if (!itemSecernIds.length && isAttr) {
      const items = {
        bySecernId: {},
        allSecernIds: [],
      };
      searchCondition = {};
      return dispatch(csvActionCreators.receiveItemList(items, 0, storedContentList, searchCondition));
    }

    const searchInfo = {
      startPosition: startPosition || 0,
      returnMaxNum: RETURN_MAX_NUM,
    };
    let boxSecernIdList = [];
    if (courseName && courseName.length) {
      const { courseList } = await courseRequest.postCourseGetList({
        selectTargetData: SELECT_TARGET_DATA.DATA,
        searchInfo: { courseName },
      });
      if (courseList.length) {
        const courseSecernIdList = courseList.map(course => course.courseSecernId);
        searchInfo.courseSecernIdList = courseSecernIdList;
      } else {
        const items = {
          bySecernId: {},
          allSecernIds: [],
        };
        searchCondition = {};
        return dispatch(csvActionCreators.receiveItemList(items, 0, storedContentList, searchCondition));
      }
    }
    if (boxName && boxName.length) {
      const { boxList } = await boxRequest.postBoxGetList({
        selectTargetData: SELECT_TARGET_DATA.DATA,
        searchInfo: { boxName },
      });
      if (boxList.length) {
        boxSecernIdList = boxList.map(box => box.boxSecernId);
        searchInfo.parentBoxSecernIdList = boxSecernIdList;
      } else {
        const items = {
          bySecernId: {},
          allSecernIds: [],
        };
        searchCondition = {};
        return dispatch(csvActionCreators.receiveItemList(items, 0, storedContentList, searchCondition));
      }
    }

    if (itemSecernIds.length && isAttr) {
      searchInfo.itemList = itemSecernIds;
    }

    if (contentTypeRadio) {
      searchInfo.dataAffiliationType = contentTypeRadio;
    }
    contentType && (searchInfo.contentType = parseInt(contentType, 10));
    contentName && contentName.length && (searchInfo.itemName = contentName);
    // Send API to get all items
    const { itemList, recordNum } = await itemRequest.postItemGetList({ selectTargetData: SELECT_TARGET_DATA.DATA, searchInfo });
    // Send API to get needed number item
    if (itemList.length) {
      if (recordNum > 0) {
        const items = itemList.reduce((acc, cur) => {
          const { itemSecernId } = cur;
          acc.bySecernId[itemSecernId] = cur;
          acc.allSecernIds.push(itemSecernId);
          if (!storedContentList.bySecernId[itemSecernId]) {
            storedContentList.bySecernId[itemSecernId] = cur;
          }
          if (storedContentList.allSecernIds.indexOf(itemSecernId) < 0) {
            storedContentList.allSecernIds.push(itemSecernId);
          }
          return acc;
        }, { recordNum, bySecernId: {}, allSecernIds: [] });

        return dispatch(csvActionCreators.receiveItemList(items, recordNum, storedContentList, searchCondition));
      }
    } else {
      const items = { allSecernIds: [], bySecernId: {} };
      searchCondition = {};
      return dispatch(csvActionCreators.receiveItemList(items, 0, storedContentList, searchCondition));
    }
  };
}

export function searchUserService({ userName, loginId, userAttributeKeyNum,
  userAttributeSearchText, isDisplayHibernateUsers, selectedTargetGroup }, startPosition = 0) {
  return async (dispatch, getState) => {
    let searchByUserAtribute = (async () => [])();
    let isAttr = false;
    let userSecernIds = [];
    const storedUserList = getState().csvDownload.storedUserList;
    const searchCondition = {
      userName,
      loginId,
      userAttributeKeyNum,
      userAttributeSearchText,
      isDisplayHibernateUsers,
      selectedTargetGroup,
    };
    // Search with user attribute
    if (userAttributeSearchText) {
      isAttr = true;
      const searchInfo = {
        userAttributeType: USER_ATTRIBUTE_TYPE.USER,
        userAttributeKeyNum,
        userAttributeSearchText,
      };
      searchByUserAtribute = userAttributeRequest.postUserAttributeGetList({ searchInfo })
        .then(({ userAttributeList }) => userAttributeList.map(cur => cur.secernId));

      userSecernIds = await searchByUserAtribute;
    }
    if (!userSecernIds.length && isAttr) {
      const targetUser = {
        bySecernId: {},
        allSecernIds: [],
        recordNum: 0,
      };

      return dispatch(csvActionCreators.receiveServiceUserList(targetUser, 0, storedUserList, {}));
    }

    let searchInfo = {
      returnMaxNum: RETURN_MAX_NUM,
      startPosition,
      userType: 2,
    };

    userName && userName.length && (searchInfo.userName = userName);
    loginId && loginId.length && (searchInfo.loginId = loginId);

    if (userSecernIds && isAttr) {
      searchInfo.userSecernIdList = userSecernIds;
    }

    if (isDisplayHibernateUsers) {
      searchInfo.dormantState = null;
    } else {
      searchInfo.dormantState = 0;
    }

    if (selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      searchInfo.groupSecernId = selectedTargetGroup.groupSecernId;
    }

    const { recordNum, userList } = await userRequests.postUserGetList({ searchInfo });

    searchInfo = {
      startPosition: 0,
      userList: userList ? userList.map(({ userSecernId }) => userSecernId) : [],
    };
    // Send request postUserGroupRelationGetList
    const { groupRelationList } = await groupRequests.postUserGroupRelationGetList({ searchInfo });
    const { groupList } = await groupRequests.postGroupGetStructure(undefined, true);


    const groupListByUser = UserUtils.convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    const users = userList.reduce((acc, cur) => {
      const { userSecernId } = cur;
      const groupSecernIdList =
        groupListByUser[cur.userSecernId] && groupListByUser[cur.userSecernId].groupSecernId
          ? groupListByUser[cur.userSecernId].groupSecernId
          : [];
      const nameGroup = UserUtils.convertGroupListIdToGroupName(groupSecernIdList, groupList);
      cur.groupName = nameGroup;
      acc.bySecernId[userSecernId] = cur;
      acc.allSecernIds.push(userSecernId);
      if (!storedUserList.bySecernId[userSecernId]) {
        storedUserList.bySecernId[userSecernId] = cur;
      }
      if (storedUserList.allSecernIds.indexOf(userSecernId) < 0) {
        storedUserList.allSecernIds.push(userSecernId);
      }
      return acc;
    }, { recordNum, bySecernId: {}, allSecernIds: [] });

    return dispatch(csvActionCreators.receiveServiceUserList(users, recordNum, storedUserList, searchCondition));
  };
}

export function resetDataForCSVDownload() {
  return csvActionCreators.resetCSVDownload();
}

export function unMountUserDialog() {
  return csvActionCreators.resetUserDialog();
}

export function unMountCourseDialog() {
  return csvActionCreators.resetCourseDialog();
}

export function unMountContentDialog() {
  return csvActionCreators.resetContentDialog();
}

export function unMountBoxDialog() {
  return csvActionCreators.resetBoxDialog();
}

// Step 10.0.0 START
export function initBoxList() {
  const data = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo: {
      returnMaxNum: RETURN_MAX_NUM,
    },
  };
  return async (dispatch) => {
    const { boxList, recordNum } = await boxRequest.postBoxGetList(data);
    return dispatch(csvActionCreators.receiveBoxList(boxList, recordNum));
  };
}

export function getBoxListPaging(position) {
  const data = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo: {
      startPosition: position,
      returnMaxNum: RETURN_MAX_NUM,
    },
  };
  return async (dispatch) => {
    const { boxList, recordNum } = await boxRequest.postBoxGetList(data);
    return dispatch(csvActionCreators.receiveBoxList(boxList, recordNum));
  };
}

export function searchBox(boxName, userAttributeKeyNum, userAttributeSearchText, startPosition = 0) {
  return async (dispatch) => {
    let searchByUserAtribute = (async () => [])();
    let isAttr = false;
    let searchCondition = { boxName, userAttributeKeyNum, userAttributeSearchText };

    if (userAttributeSearchText) {
      isAttr = true;
      if (userAttributeKeyNum === 0) {
        userAttributeKeyNum = 1;
      }
      const searchInfo = {
        userAttributeType: USER_ATTRIBUTE_TYPE.BOX,
        userAttributeKeyNum,
        userAttributeSearchText,
      };
      searchByUserAtribute = userAttributeRequest.postUserAttributeGetList({ searchInfo })
        .then(({ userAttributeList }) => userAttributeList.map(cur => cur.secernId));
    }
    const boxSecernIds = await searchByUserAtribute;

    if (!boxSecernIds.length && isAttr) {
      const targetUser = {
        bySecernId: {},
        allSecernIds: [],
        recordNum: 0,
      };
      searchCondition = {};
      return dispatch(csvActionCreators.receiveBoxList([], 0, searchCondition));
    }

    const data = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        boxName,
        returnMaxNum: RETURN_MAX_NUM,
        startPosition,
      },
    };
    if (boxSecernIds.length && isAttr) {
      data.searchInfo.boxList = boxSecernIds;
    }

    const { boxList, recordNum } = await boxRequest.postBoxGetList(data);
    if (recordNum > 0) {
      return dispatch(csvActionCreators.receiveBoxList(boxList, recordNum, searchCondition));
    }
    searchCondition = {};
    return dispatch(csvActionCreators.receiveBoxList(boxList, recordNum, searchCondition));
  };
}

export function addCheckedBoxToList({ removedSecern, addedList = [], removedAll }) {
  return csvActionCreators.receiveAddedBoxList(removedSecern, addedList, removedAll);
}

export function addCheckedBoxToTargetList(addedBoxList) {
  return csvActionCreators.receiveTargetBoxList(addedBoxList);
}

export function resetBox(addedBoxList) {
  return csvActionCreators.resetBoxData(addedBoxList);
}

export function postGetLoginHistoryData(param) {
  return async (dispatch, getState) => {
    const {
      targetDateFrom,
      targetDateTo,
      userType,
      isSuperuserLoginHistoryCSVPage,
    } = param;
    const searchParam = {
      targetDateFrom,
      targetDateTo,
    };

    if (isSuperuserLoginHistoryCSVPage) {
      await loginHistoryRequest.postGetEnterpriseLoginHistoryData(searchParam);
    } else {
      searchParam.userType = userType;
      await loginHistoryRequest.postGetServiceLoginHistoryData(searchParam);
    }
  };
}

// Step 10.0.0 END
